export const TEXTS = {
  CLOSE_BUTTON: 'Close popover',
};
